export default "__VITE_ASSET__Dp3fv$bi__"